<template>
  <div class="dataCleaningDetailView-container">
    <div class="dataCleaningDetailView-container-in">
      <div class="dc-detail-back flex_center_start"
      @click="toBack"
      >
        <img src="../../../assets/images/de_datail_back.png" alt="" />
        Back
      </div>
      <div class="flex_center_bettwen dc-detail-title-box">
        <div class="dc-detail-title">Detail View</div>
        <div class="flex_center_start">
          <el-button
            class="dc-detail-btn-line"
            style="margin:0 17px 0 0;"
            @click="prevPage" 
            :disabled="currentPage === 1"
            >Prev Page</el-button
          >
          <el-button
            class="dc-detail-btn-line"
            style="margin:0 17px 0 0;"
            @click="nextPage"
            :disabled="currentPage === totalPages"
            >Next Page</el-button
          >
          <el-button
            type="primary" 
            class="dc-detail-btn"
            @click="toDownload"
            >Download</el-button
          >
          
        </div>
      </div>
      <!-- <template v-if="paginatedItems.uploadCleaningResultList"> -->
        <div class="dc-detail-descriptions"
          v-for="(item, index) in paginatedItems"
          :key="index"
        >
          <div
            v-for="(itemChild, indexChild) in item.uploadCleaningResultList"
            :key="indexChild"
            class="dc-detail-description-item"
          >
            <div class="description-item-label">{{ itemChild.fieldDec }}</div>
            <div class="description-item-content">{{ itemChild.fieldValue }}</div>
          </div>
        </div>
      <!-- </template> -->
    </div>
  </div>
</template>

<script>

export default {
  components: {
    
  },
  props: {
    detailData: { type: Array, default: () => [] },
    current: { type: Number, default: 1 }
  },
  data() {
    return {
      allItems: [ /* 这里是你的所有数据 */ ], 
      currentPage: 1, // 当前页码，默认第一页
      itemsPerPage: 1 // 每页显示的项目数量
    };
  },
  computed: {
    // 计算总页数
    totalPages() {
      return Math.ceil(this.allItems.length / this.itemsPerPage);
    },
    // 获取当前页需要显示的数据，是个数组
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      let currentItem = this.allItems.slice(start, end);
      let objData = currentItem&&currentItem[0] || {};
      console.log('当前展示的', JSON.parse(JSON.stringify(objData)));
      return  currentItem || [];
    },
    
  },
  watch: {
    detailData: {
      handler(newVal) {
        console.log(newVal);
        this.allItems = newVal;
        
      },
      immediate: true
    },
    current: {
      handler(newVal) {
        console.log(newVal);
        this.currentPage = newVal;
      },
      immediate: true
    },
  },
  methods: {
    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    toBack(){
      this.$emit('showDetailViewBack');
    },
    toDownload(){
      this.$emit('toDownloadSingleFn', this.paginatedItems[0])
    },
  },
};
</script>
<style scoped>
.dataCleaningDetailView-container{
  width: 100%;
  /* height: 968px; */
  padding: 20px 20px;
  overflow: auto;
}
.dataCleaningDetailView-container-in{
  background: #FFFFFF;
  box-shadow: 0px 2px 14px 0px rgba(0,0,0,0.12);
  border-radius: 4px;
  padding: 36px 40px 20px;
}
.dc-detail-back{
  font-size: 24px;
  color: #1A2332;
  line-height: 34px;
  font-family: Arial Bold;
  width: 100px;
  cursor: pointer;
}
.dc-detail-back img{
  margin-right: 18px;
}
.dc-detail-btn{
  width: 160px;
  height: 40px;
  font-size: 18px;
}
.dc-detail-btn-line{
  width: 160px;
  height: 40px;
  font-size: 18px;
  color: #B98B73 !important;
  border: 1px solid #B98B73 !important;
}
.dc-detail-title{
  font-size: 22px;
  color: #1A2332;
  line-height: 34px;
}
.dc-detail-title-box{
  margin: 7px 0 20px;
}
.dc-detail-descriptions {
  display: flex;
  flex-wrap: wrap;
}
.dc-detail-description-item {
  width: 50%; 
  display: flex;
  border-bottom: 1px solid #CCCCCC;
  font-size: 18px;
  color: #1A2332;
  align-items: center; 
}
.dc-detail-descriptions > .dc-detail-description-item:nth-last-child(1):nth-child(odd) {
  width: 100%;
}
.description-item-label {
  line-height: 30px;
  padding: 15px 10px 15px 20px;
  width: 300px;
  white-space: normal;
  word-break: break-all;
  flex-shrink: 0;
  background: #F2F5F9;
  display: flex;
  align-items: center;
  height: 100%;
}
.description-item-content {
  line-height: 30px;
  padding: 15px 10px 15px 20px;
  flex: 1;
  white-space: normal;
  word-break: break-all;
  display: flex;
  align-items: center;
}
@media (max-width: 1920px) {
  /* 标题字体 20px */
  .dc-detail-title{
    font-size: 20px !important;
  }
  /* 文本字体 16px */
  .dc-detail-description-item,
  .dc-detail-btn-line,
  .dc-detail-btn
  {
    font-size: 16px !important;
  }
  
  /* 圆角 */
  .dataCleaningDetailView-container-in{
    border-radius: 10px;
  }
  /* padding + margin  */
  .description-item-label,
  .description-item-content
  {
    padding: 10px 10px 10px 20px;
  }
  
}
@media (max-width: 1440px) {
  /* 标题字体 18px */
  .dc-detail-title{
    font-size: 18px !important;
  }
  /* 文本字体 14px */
  .dc-detail-description-item,
  .dc-detail-btn-line,
  .dc-detail-btn
  {
    font-size: 14px !important;
  }
  
  /* 圆角 */
  .dataCleaningDetailView-container-in{
    border-radius: 8px;
  }
  /* padding + margin  */
  .description-item-label,
  .description-item-content
  {
    padding: 7px 10px 7px 20px;
  }
  
}
</style>
